import { Store } from "vuex";

// En localStorage solo va la marca de vigencia, nunca el token. Ver claude.md, sección 20.
const CANAL = "rc-sesion";
const MARCA = "rc_sesion_hasta";
const CLAVE_SESION = "vuex-sesion";
const ESPERA_MAXIMA_MS = 300;

// expires_at llega como "AAAA-MM-DD hh:mm:ss"; con la T es ISO en hora local y Safari también lo entiende.
function vigente(expireTime: any): boolean {
  if (!expireTime) return false;
  const vence = new Date(String(expireTime).replace(" ", "T")).getTime();
  return vence > Date.now();
}

function leerMarca(): string | null {
  try {
    return localStorage.getItem(MARCA);
  } catch (error) {
    return null;
  }
}

function guardarMarca(expireTime: any) {
  try {
    localStorage.setItem(MARCA, String(expireTime));
  } catch (error) {}
}

function borrarMarca() {
  try {
    localStorage.removeItem(MARCA);
  } catch (error) {}
}

function abrirCanal(): BroadcastChannel | null {
  return typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(CANAL);
}

export function sesionEntrePestanas(store: Store<any>) {
  const canal = abrirCanal();

  if (canal) {
    canal.onmessage = (evento: MessageEvent) => {
      const mensaje = evento.data || {};
      if (mensaje.tipo === "pedir") {
        if (!store.state.token || !vigente(store.state.expireTime)) return;
        let sesion = null;
        try {
          sesion = sessionStorage.getItem(CLAVE_SESION);
        } catch (error) {}
        if (sesion) canal.postMessage({ tipo: "sesion", sesion });
      } else if (mensaje.tipo === "logout" && store.state.token) {
        try {
          sessionStorage.removeItem(CLAVE_SESION);
        } catch (error) {}
        location.reload();
      }
    };
  }

  // El aviso de logout mira si había token antes de la mutación: logout lo deja en null, y el guard de rutas también
  // hace logout en pestañas sin sesión, que no deben cerrar la de las demás.
  let teniaToken = !!store.state.token;

  store.subscribe((mutacion, state) => {
    const habiaSesion = teniaToken;
    teniaToken = !!state.token;
    if ((mutacion.type === "setToken" || mutacion.type === "setExpireTime") && state.token && vigente(state.expireTime)) {
      guardarMarca(state.expireTime);
    } else if ((mutacion.type === "logout" || mutacion.type === "logAndReconnect") && habiaSesion) {
      borrarMarca();
      if (canal) canal.postMessage({ tipo: "logout" });
    }
  });
}

export function recuperarSesion(store: Store<any>): Promise<void> {
  const hasta = leerMarca();
  if (store.state.token || typeof BroadcastChannel === "undefined" || !vigente(hasta)) {
    if (hasta && !vigente(hasta)) borrarMarca();
    return Promise.resolve();
  }

  return new Promise(resolve => {
    const canal = new BroadcastChannel(CANAL);
    const terminar = () => {
      clearTimeout(espera);
      canal.close();
      resolve();
    };
    const espera = setTimeout(() => {
      borrarMarca();
      terminar();
    }, ESPERA_MAXIMA_MS);

    canal.onmessage = (evento: MessageEvent) => {
      const mensaje = evento.data || {};
      if (mensaje.tipo !== "sesion" || typeof mensaje.sesion !== "string") return;
      try {
        const sesion = JSON.parse(mensaje.sesion);
        sessionStorage.setItem(CLAVE_SESION, mensaje.sesion);
        store.replaceState({ ...store.state, ...sesion });
      } catch (error) {}
      terminar();
    };
    canal.postMessage({ tipo: "pedir" });
  });
}
